<template>
  <div>
    <div
      v-if="selected_report"
      id="standard-index-view"
      class="position-relative"
      :style="`font-family: ${selected_report.font_family}`"
    >
      <b-overlay class="mt-5" :show="loadingShow" no-wrap />

      <template v-if="theme_option && theme_option.layout_code === 'bh_test'">
        <ViewerHeaderCover
          :theme_option="!theme_option ? {} : theme_option"
          :dark_logo_url="dark_logo_url === null ? false : dark_logo_url"
          :content_list_open="content_list_open"
          :main_bg_color_gradient="main_bg_color_gradient"
          :show_sasb_table="show_sasb_table"
          :show_gri_table="show_gri_table"
          :show_tcfd_table="show_tcfd_table"
          :show_dc_table="show_dc_table"
          :active_dc_table="active_dc_table"
          :active_gri_table="active_gri_table"
          :active_sasb_table="active_sasb_table"
          :active_tcfd_table="active_tcfd_table"
          @showTableView="showTableView"
        />
      </template>

      <template>
        <b-container v-view="viewHandlerNav" class="bg-white">
          <WaterMark v-if="selected_report.sample_report" />

          <!-- 테스트 -->
          <tcfd-table
            v-if="show_tcfd_table"
            :modal_table="false"
            :business_case_mode="theme_option !== null ? theme_option.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />

          <sasb-table
            v-if="show_sasb_table"
            :modal_table="false"
            :business_case_mode="theme_option !== null ? theme_option.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />

          <gri-table
            v-if="show_gri_table"
            :modal_table="false"
            :business_case_mode="theme_option !== null ? theme_option.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />
        </b-container>
      </template>

      <div>
        <div v-view="viewHandlerNav" class="padded-container">
          <WaterMark v-if="selected_report.sample_report" />

          <data-center-table
            v-if="show_dc_table"
            v-view="dcViewHandlerNav"
            :modal_table="false"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />
        </div>
      </div>
    </div>

    <!-- 인쇄영역 -->
    <div v-if="print_mode" class="d-none d-print-block position-absolute w-100">
      <div id="full-report-preview">
        <b-container class="px-6 vh-100">
          <b-row no-gutters class="h-100">
            <b-col cols="6" class="pl-3">
              <h1 class="f-300 mb-5 line-height-lg" style="padding-top: 10vh">
                {{ lang != 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
              </h1>
              <h6 class="">{{ selected_report.start_date }} ~ {{ selected_report.end_date }}</h6>
            </b-col>
            <b-col class="d-flex justify-content-end align-items-end pr-5">
              <div
                v-if="
                  theme_option && !theme_option.is_dark_option && selected_report.logo_path != null
                "
                style="padding-bottom: 7vh"
              >
                <b-img
                  :src="$store.state.static_host + selected_report.logo_path"
                  class="report-logo-regular"
                />
              </div>
              <div
                v-if="theme_option && theme_option.is_dark_option && dark_logo_url !== null"
                style="padding-bottom: 7vh"
              >
                <b-img :src="dark_logo_url" class="report-logo-regular" />
              </div>
            </b-col>
          </b-row>
        </b-container>

        <div class="bgray-200">
          <b-container class="px-5 py-5">
            <b-card class="p-4">
              <h3 class="mb-5">Contents</h3>
              <ContentsListBasic />
            </b-card>
          </b-container>
        </div>

        <b-container class="px-5 py-5">
          <!-- v-if="show_tcfd_table" -->
          <tcfd-table
            v-if="show_tcfd_table"
            :modal_table="false"
            :print_mode="true"
            :business_case_mode="theme_option !== null ? theme_option.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />

          <!-- v-if="show_sasb_table" -->
          <sasb-table
            v-if="show_sasb_table"
            :modal_table="false"
            :print_mode="true"
            :business_case_mode="theme_option !== null ? theme_option.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />

          <!-- v-if="show_gri_table" -->
          <gri-table
            v-if="show_gri_table"
            :modal_table="false"
            :print_mode="true"
            :business_case_mode="theme_option !== null ? theme_option.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />

          <data-center-table
            v-if="show_dc_table"
            :modal_table="false"
            :print_mode="true"
            :table_mode="theme_option !== null ? theme_option.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.table_header_font_color : ''
            "
          />
        </b-container>

        <b-container v-if="assurance_status == 6" class="assurance-statement py-5 px-5 bgray-100">
          <template>
            <h3 id="rpa0" class="pt-3 mb-5">
              Appendix. {{ lang != 'ENG' ? '제3자 검증의견서' : 'Independent Assurance Statement' }}
            </h3>
            <ViewAssuranceStatement :preview_mode="true" />
          </template>
        </b-container>

        <b-container class="px-4 px-lg-5 gray-550 f-90 d-flex justify-content-between footer">
          <div class="tail-line">
            {{ lang != 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
          </div>
          <div v-if="selected_report.logo_path != null">
            <b-img
              :src="$store.state.static_host + selected_report.logo_path"
              class="report-logo-small"
            />
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import * as ih from '@/components/util';
import ContentsListBasic from './viewer_components/ContentsListBasic.vue';
import TCFDTable from './viewer_components/TCFDTable.vue';
import DataCenterTableMicro from './viewer_components/DataCenterTableMicro.vue';
import ViewAssuranceStatement from '@/components/report_preview/appendix_subs/ViewAssuranceStatement';
import WaterMark from '@/components/report_preview/gri2021_viewer/WaterMark';
import ViewerHeaderCover from './viewer_components/ViewerHeaderCover.vue';
import GRITable2021Micro from './viewer_components/GRITable2021Micro.vue';
import SASBTableMicro from './viewer_components/SASBTableMicro.vue';
import axios from 'axios';

export default {
  name: 'FullView2021Micro',
  components: {
    ContentsListBasic,
    'gri-table': GRITable2021Micro,
    'sasb-table': SASBTableMicro,
    'tcfd-table': TCFDTable,
    'data-center-table': DataCenterTableMicro,
    ViewAssuranceStatement,
    WaterMark,
    ViewerHeaderCover
  },
  props: {
    show_table_list: { type: Boolean, default: false },
    show_business_case_list: { type: Boolean, default: false },
    reload: { type: Boolean, default: false }
  },
  data() {
    return {
      low_height: false,
      show_nav: true,
      content_list_open: false,
      theme_option: null,
      loadingShow: true,
      cover_img_url: null,
      dark_logo_url: null,

      show_gri_table: false,
      show_sasb_table: false,
      show_tcfd_table: false,

      show_dc_table: false,
      active_dc_table: false,

      active_gri_table: false,
      active_sasb_table: false,
      active_tcfd_table: false,
      type: null,

      original_url: window.location.href.split('&t')[0],
      print_mode: false
    };
  },
  computed: {
    ...mapGetters(['is_viewer']),
    ...mapState(['backend_host', 'static_host']),
    ...mapState('report_list', ['lang', 'view_mode']),
    ...mapGetters('report_list', ['selected_report', 'current_report_code']),
    ...mapState('gri2021_report_view', ['report_structure', 'report_contents_loaded']),
    ...mapGetters('gri2021_report_view', [
      'report_topic_specific_categories',
      'report_universal_categories',
      'report_topic_types'
    ]),
    ...mapActions('assurance', ['readAssuranceStatusByReportCode']),
    ...mapState('assurance', ['assurance_status']),
    main_color() {
      return `color:` + this.selected_report.main_color;
    },
    main_bg_color() {
      return `background-color:` + this.selected_report.main_color + `;important!`;
    },
    main_color_sub() {
      return (
        `color:` +
        this.selected_report.main_color +
        `; border-top: 1px solid ` +
        this.selected_report.main_color +
        `!important` +
        `; border-bottom: 1px solid ` +
        this.selected_report.main_color
      );
    },
    main_bg_color_gradient() {
      if (
        !this.theme_option?.cover_active ||
        this?.cover_img_url === null ||
        this?.cover_img_url === ''
      ) {
        return (
          `background:linear-gradient(0deg, ` +
          this.selected_report.main_color +
          ` -50%, rgba(239,239,239,1) 60%);important!`
        );
      } else {
        const theme_style = {
          'background-image': `url(${this.cover_img_url})`,
          'background-size': 'cover',
          'background-repeat': 'no-repeat',
          opacity: `${this.theme_option.cover_alpha}`,
          color: `${this.theme_option?.title_color}`
        };

        return theme_style;
      }
    }
  },
  mounted() {
    if (this.is_viewer) {
      this.update_view_mode('viewer');
    } else {
      this.update_view_mode('editor');
    }
  },
  async created() {
    if (this.reload == true) {
      this.update_report_contents_loaded(false);
    }
    await this.get_report_theme_info();
    this.check_report_type();
    // if(this.report_contents_loaded != true){
    if (process.env.VUE_APP_REPORT_CODE === undefined) {
    } else {
      // await this.readAssuranceStatusByReportCode({ report_code: this.current_report_code });
      // this.readAllReportListForViewer({ report_code: this.current_report_code });
    }
    document.querySelector('title').textContent = this.selected_report.report_name;
    await this.initCss();

    this.scrollToHash();
  },
  mounted() {
    window.addEventListener('scroll', this.handleContentList);

    if (this.view_mode !== 'editor') {
      const params = ih.getParamsFromQueryString();
      if (params && params?.lv1 !== undefined) {
        this.update_lv1_key(params.lv1);
        this.update_lv2_key(params.lv2);
      }
    }
  },
  beforeDestroy() {
    this.change_lang('KOR');
    window.removeEventListener('scroll', this.handleContentList);
  },
  methods: {
    ...mapMutations('data_center', ['update_lv1_key', 'update_lv2_key']),
    ...mapMutations('gri2021_report_view', ['update_report_contents_loaded']),
    ...mapMutations('report_list', ['update_view_mode', 'change_lang']),
    ...mapActions('report_list', ['readAllReportListForViewer']),
    ...mapActions('assurance', ['readAssuranceListByReportCode']),
    ...mapActions('report_contents', ['fetchSelectedSasb']),
    check_report_type() {
      if (this.selected_report) {
        for (const i of Object.keys(this.selected_report.report_type)) {
          if (i.split('v')[0] === 'GRI') {
            this.active_gri_table = true;
          } else if (i.split('v')[0] === 'SASB') {
            this.fetchSelectedSasb(this.current_report_code);
            this.active_sasb_table = true;
          } else if (i.split('v')[0] === 'TCFD') {
            this.active_tcfd_table = true;
          }
        }

        if (this.selected_report?.data_center) {
          this.active_dc_table = true;
        } else {
        }
      }
    },
    showTableView(type) {
      if (type === 'GRI') {
        this.show_gri_table = true;
        this.show_sasb_table = false;
        this.show_tcfd_table = false;
        this.show_dc_table = false;
      } else if (type === 'SASB') {
        this.show_gri_table = false;
        this.show_sasb_table = true;
        this.show_tcfd_table = false;
        this.show_dc_table = false;
      } else if (type === 'TCFD') {
        this.show_gri_table = false;
        this.show_sasb_table = false;
        this.show_tcfd_table = true;
        this.show_dc_table = false;
      } else if (type === 'Data Center' || type === 'DATA_CENTER') {
        this.show_gri_table = false;
        this.show_sasb_table = false;
        this.show_tcfd_table = false;
        this.show_dc_table = true;
      } else {
        this.show_gri_table = false;
        this.show_sasb_table = false;
        this.show_tcfd_table = false;
        this.show_dc_table = false;
      }

      if (type) {
        ih.updateParamsFromQueryString('t', type.toLowerCase());
      }
    },
    toggleLang() {
      if (this.lang == 'KOR') {
        this.change_lang('ENG');
        document.querySelector('title').textContent = this.selected_report.report_name_e;

        const newUrl = `${window.location.href}&l=KOR`;
        if (window.location.href.includes('&l=')) {
          window.history.pushState({}, '', newUrl);
        }
      } else {
        this.change_lang('KOR');
        document.querySelector('title').textContent = this.selected_report.report_name;

        const newUrl = `${window.location.href}&l=ENG`;
        if (!window.location.href.includes('&l=')) {
          window.history.pushState({}, '', newUrl);
        }
      }
    },
    viewHandlerNav(event) {
      if (event.type !== 'progress' && event.scrollPercent > 0.035) {
        this.show_nav = true;
      } else {
        this.show_nav = false;
      }
    },
    dcViewHandlerNav() {
      if (window.scrollY > 0 && window.innerWidth > 300) {
        this.show_nav = true;
      } else {
        this.show_nav = false;
      }
    },
    handleContentList() {
      if (window.scrollY > 0 && window.innerWidth > 800) {
        this.content_list_open = true;
      } else {
        this.content_list_open = false;
      }
    },
    async get_report_theme_info() {
      try {
        let params = {};

        if (this.view_mode !== 'editor') {
          params = ih.getParamsFromQueryString();
        }

        if (params && params?.t !== undefined) {
          this.type = params?.t.toUpperCase();
        } else {
          this.type = null;
        }

        const report_url = process.env.VUE_APP_REPORT_CODE
          ? process.env.VUE_APP_REPORT_CODE
          : typeof this.selected_report === 'undefined'
          ? params?.r
          : this.selected_report.report_url;
        this.showTableView(this.type);

        const request_url = report_url
          ? '/custom_theme/get_theme_info?report_url=' + report_url
          : '/custom_theme/get_theme_info?report_code=' + this.current_report_code;

        const _res_theme_option = await axios.get(this.backend_host + request_url);
        if (_res_theme_option.data.code) {
          const _theme_option = { ..._res_theme_option.data.theme_info };

          this.cover_img_url = !_theme_option.cover_path
            ? null
            : this.static_host + _theme_option.cover_path.replaceAll('\\', '/');
          this.dark_logo_url = !_theme_option.dark_logo_path
            ? null
            : this.static_host + _theme_option.dark_logo_path.replaceAll('\\', '/');
          this.theme_option = { ..._theme_option };

          this.loadingShow = false;
        } else {
          this.loadingShow = false;
          window.alert(_res_theme_option.data.message);
          return;
        }
      } catch (error) {
        this.$Sentry.captureException(error);
      }
    },
    async initCss() {
      const beforeStyledSheet = document.getElementsByClassName('customized-css-styling');
      if (beforeStyledSheet.length > 0) {
        for (const element of beforeStyledSheet) {
          element.remove();
        }
      }

      const result = await axios.post(
        process.env.VUE_APP_BACKENDHOST + '/custom_theme/add_custom_theme',
        {
          report_code: this.current_report_code
        }
      );

      const styleElement = document.createElement('style');
      styleElement.classList.add('customized-css-styling');
      styleElement.innerHTML = result.data.css_content;
      document.head.appendChild(styleElement);

      this.loadingShow = false;
    },

    scrollToHash() {
      this.$nextTick(() => {
        const hash = window.location.hash;
        if (hash) {
          const element = document.querySelector(hash);

          if (element && element !== 'null') {
            element.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
        }
      });
    }
  }
};
let lastScroll = document.documentElement.scrollTop || 0;
document.addEventListener('scroll', function () {
  const scrollTop = document.documentElement.scrollTop;
  if (scrollTop > lastScroll) {
  } else {
  }
  lastScroll = scrollTop;
});
</script>
<style>
@media print {
  .footer {
    background-color: #fff;
    color: black;
    text-align: center;
    padding: 0;
    margin-top: auto;
  }
}

.assurance-statement {
  page-break-before: always;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  page-break-inside: avoid;
}
</style>
